import { iconNames as generatedIconNames } from "./generated/names.ts";

export const ICON_NAMES = [
  ...generatedIconNames,
  "google",
  "google-calendar",
  "microsoft-outlook",
] as const;
export type IconName = (typeof ICON_NAMES)[number];

/**
 * The roster guard. A literal, not `ICON_NAMES.length`: the registry tests
 * compare the live roster against this number, so adding or removing a glyph
 * fails until the same commit bumps it. `IconName` alone catches a removed
 * name only at an active call site.
 */
export const ICON_COUNT = 353;

const ICON_NAME_SET: ReadonlySet<string> = new Set(ICON_NAMES);

export function isIconName(value: string | null | undefined): value is IconName {
  return value != null && ICON_NAME_SET.has(value);
}

export function toIconName(
  value: string | null | undefined,
): IconName | undefined {
  return isIconName(value) ? value : undefined;
}
